export enum ConfigurationDomain {
  FEATURE_ACCESS = 'feature-access',
  TIME_REGISTRATION_POLICY = 'time-registration-policy',
  ABSENCE = 'absence',
  JOINT_COMMISSIONS = 'joint-commissions',
  SECURITY_AUTHENTICATION = 'security-authentication',
  CONTRACT_VALIDATION_COMPLIANCE = 'contract-validation-compliance',
  PERMISSIONS = 'permissions',
}
